import {
	Link,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
	TypographyProps
} from '@mui/material';
import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import React from 'react';
import MDCode from './elements/MDCode';
import MDImg from './elements/MDImg';
import MDList from './elements/MDList';
import MDParagraph from './elements/MDParagraph';
import MDTable from './elements/MDTable';
import MDWrapper from './elements/MDWrapper';

interface IMDRendererProps {
	md: string;
	overrides?: MarkdownToJSX.Overrides;
}

const TYPOGRAPHY_OVERRIDES = Object.fromEntries(
	['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map((k) => [
		k,
		{
			component: Typography,
			props: {
				variant: k,
				component: 'div'
			} as TypographyProps
		}
	])
);

const MDRenderer: React.FC<IMDRendererProps> = ({ md, overrides = {} }) => (
	<Markdown
		options={{
			forceWrapper: true,
			wrapper: MDWrapper,
			overrides: {
				...TYPOGRAPHY_OVERRIDES,
				p: {
					component: MDParagraph
				},
				img: {
					component: MDImg
				},
				ol: {
					component: MDList
				},
				ul: {
					component: MDList
				},
				li: {
					component: Typography,
					props: { component: 'li' }
				},
				a: {
					component: Link
				},
				code: {
					component: MDCode
				},
				table: {
					component: MDTable
				},
				thead: {
					component: TableHead
				},
				tbody: {
					component: TableBody
				},
				tr: {
					component: TableRow
				},
				th: {
					component: TableCell
				},
				td: {
					component: TableCell
				},
				...overrides
			}
		}}
	>
		{md}
	</Markdown>
);

export default MDRenderer;
